var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-search-loader"},[_c('SvgLinkCircle',{staticClass:"transform -rotate-90 w-full"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }